var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDraftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0711 16.1372L4.85215 17.2922C3.65931 17.5137 3.0629 17.6244 2.71931 17.2808C2.37572 16.9372 2.48647 16.3408 2.70798 15.1478L3.86281 8.92858C4.048 7.93135 4.14059 7.43271 4.4693 7.13142C4.79803 6.83013 5.3992 6.77133 6.60154 6.65373C7.76035 6.54039 8.85704 6.14314 10.0001 5L15.0001 10.0004C13.857 11.1436 13.4595 12.2395 13.346 13.3984C13.2283 14.6009 13.1694 15.2022 12.8681 15.5308C12.5669 15.8595 12.0683 15.9521 11.0711 16.1372Z",
    stroke: "#616874",
    strokeWidth: 1.67,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16628 12.6761C8.70003 12.6004 8.27374 12.3976 7.93821 12.0621M7.93821 12.0621C7.60268 11.7266 7.39986 11.3002 7.32417 10.834M7.93821 12.0621L3.33295 16.6673",
    stroke: "#616874",
    strokeWidth: 1.67,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 5C10.5937 4.12425 11.3977 2.651 12.5889 2.50915C13.402 2.41233 14.0756 3.08593 15.4228 4.43315L15.567 4.57731C16.9142 5.92453 17.5878 6.59814 17.491 7.41125C17.3491 8.60242 15.8759 9.40642 15.0001 10",
    stroke: "#616874",
    strokeWidth: 1.67,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraftIcon);
export default __webpack_public_path__ + "static/media/draft-icon.013935db77ac1014c35a4e012dc5af68.svg";
export { ForwardRef as ReactComponent };